import { PortalServico } from '@/utils/';

export default class LicitacoesServico extends PortalServico {
  async listarCampus(){
    return await this.get('wsinfo/api?name=campus&sortBy=codcam&desc=N');
  }
  async listarUnidades(codcam){
    if (codcam != null) {
      return await this.get(`wsinfo/api?name=uniddesp&length=1000&lq=codcam:${codcam}&sortBy=codunddsp&desc=N`);
    }
    return await this.get(`wsinfo/api?name=uniddesp&length=1000&sortBy=codunddsp&desc=N`);
  }
  async listarLicitacoes(dados, currentPage, token) {
    var queryLucene = this.escreveQueryLucene(dados)
    var start = (currentPage - 1)*10
    return await this.get(`wsinfo/api?name=edital&length=10&start=${start}${queryLucene}`, {
      "g-recaptcha-token": token
    });
  }
  escreveQueryLucene(dados) {
    var queryLucene = '&lq='
    for (const chave in dados) {
      if (dados[chave] !== '') {
        if (queryLucene.length > 5) {
          queryLucene += ' AND '
        }
        queryLucene += `${chave}:${dados[chave]}`
        if (chave === "objedi") {
          queryLucene += `~0.8` //precisão para encontrar palavras semelhantes
        }
      }
    }
    return queryLucene
  }
  async obterLicitacao(codpcddsp, token){
    return await this.get(`wsinfo/api?name=edital&lq=codpcddsp:${codpcddsp}`, {
      "g-recaptcha-token": token
    })
  }
  async listarItens(codpcddsp){
    return await this.get(`wsinfo/api?name=editalitem&length=1000&sortBy=numord&desc=N&lq=codpcddsp:${codpcddsp}`)
  }
  async listarArquivos(codpcddsp) {
    return await this.get(`wsinfo/api?name=editalarq&length=1000&sortBy=numseq&desc=N&lq=codpcddsp:${codpcddsp}`)
  }
  async listarModalidades() {
    return await this.get(`wsinfo/api?name=editalmod`)
  }
  async listarSituacoes() {
    return await this.get(`wsinfo/api?name=editalsit`)
  }
  obterArquivo(codarq_fs) {
    return `https://uspdigital.usp.br/wsinfo/arquivo?name=editalarq&codarq_fs=${codarq_fs}`
  }
}